import { IBreadcrumb } from './breadcrumbs';
import { ILocation } from './location';
import { IProject } from './project';

export interface IBuildersProjectsSchema {
  data: IBuildersProjectsData;
  status: EBuildersProjectsDataStatus;
}

export enum EBuildersProjectsDataStatus {
  Initial = 'initial',
  Fetching = 'fetching',
  Success = 'success',
}

export interface IBuildersProjectsData {
  /** Количество элементов в списке для выдачи **/
  limit: number;
  /** Номер страницы **/
  page: number;
  /** Список проектов строителей **/
  projectsList: IProject[];
  /** Информация о локации **/
  location?: ILocation;
  /** Всего элементов **/
  total: number;
  /** Хлебные крошки **/
  breadcrumbs: IBreadcrumb[];
}
